var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlignLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 1.89062H16.4375C16.8281 1.89062 17.1406 1.58594 17.1406 1.19531C17.1406 0.8125 16.8281 0.5 16.4375 0.5H1.6875C1.29688 0.5 0.992188 0.8125 0.992188 1.19531C0.992188 1.58594 1.29688 1.89062 1.6875 1.89062ZM1.6875 5.98438H10.4453C10.8359 5.98438 11.1484 5.67969 11.1484 5.28906C11.1484 4.89844 10.8359 4.59375 10.4453 4.59375H1.6875C1.29688 4.59375 0.992188 4.89844 0.992188 5.28906C0.992188 5.67969 1.29688 5.98438 1.6875 5.98438ZM1.6875 10.0781H16.4375C16.8281 10.0781 17.1406 9.77344 17.1406 9.38281C17.1406 8.99219 16.8281 8.6875 16.4375 8.6875H1.6875C1.29688 8.6875 0.992188 8.99219 0.992188 9.38281C0.992188 9.77344 1.29688 10.0781 1.6875 10.0781ZM1.6875 14.1719H10.4453C10.8359 14.1719 11.1484 13.8594 11.1484 13.4766C11.1484 13.0859 10.8359 12.7812 10.4453 12.7812H1.6875C1.29688 12.7812 0.992188 13.0859 0.992188 13.4766C0.992188 13.8594 1.29688 14.1719 1.6875 14.1719Z",
    fill: "#B2B2BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlignLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-align-left.b0a8819f43f06562ff34039d51ef54c2.svg";